export default __webpack_public_path__ + "static/media/Pavis of Fealty.d8a43cab.jpg";